import { Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function BaseModal({ isOpen, onClose, children, maxWidth = '440px' }) {
    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'var(--common-modal-bg)',
                    boxShadow: 24,
                    borderRadius: 2,
                    width: '95%',
                    maxWidth,
                    p: 0,
                    border: 'none',
                    outline: 'none',
                    overflow: 'hidden',
                }}>
                <IconButton
                    onClick={onClose}
                    aria-label="Close"
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                    }}>
                    <CloseIcon className="!text-primary" fontSize="small" />
                </IconButton>

                {children}
            </Box>
        </Modal>
    );
}

export default BaseModal;
